// Colors are kept in-app rather than added to core since this is an experiment
// and we're not sure if this feature will live. We want to roll out fast.
export const SCHOLARSHIP_BANNER_GRADIENT = "linear-gradient(135deg, #FBF2E8 15%, #B7DDFF 97%)";
export const SCHOLARSHIP_BOTTOM_SHEET_GRADIENT = "linear-gradient(to bottom, #FAF8F7, #E2F1FF)";

export const SCHOLARSHIP_LOCAL_STORAGE_KEY_PREFIX = "concorde-scholarship-response-v2";

export const SCHOLARSHIP_RESPONSES = {
  INTERESTED: "INTERESTED",
  NOT_INTERESTED: "NOT_INTERESTED",
} as const;

export type ScholarshipResponse =
  (typeof SCHOLARSHIP_RESPONSES)[keyof typeof SCHOLARSHIP_RESPONSES];

export const CONCORDE_PROGRAMS = [
  "Vocational Nursing",
  "Dental Hygiene",
  "Respiratory Therapy",
  "Surgical Technology",
  "Medical Assistant",
  "Physical Therapist Assistant",
  "RN to BSN",
] as const;

export function getScholarshipStorageKey(workerId: string): string {
  return `${SCHOLARSHIP_LOCAL_STORAGE_KEY_PREFIX}-${workerId}`;
}
